var _g, _g2, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMapMarkerSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 69,
  fill: "none",
  viewBox: "0 0 64 69"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#map-marker-small_svg__a)",
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M52 48.704c0 3.598-16 8.096-20 8.096s-20-4.498-20-8.096c0-2.483 8.954-4.497 20-4.497s20 2.014 20 4.497"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  "data-figma-bg-blur-radius": 35.556
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M52 20.286C52 36.514 36 56.8 32 56.8S12 36.514 12 20.286C12 9.082 20.954 0 32 0s20 9.082 20 20.286"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#map-marker-small_svg__b)",
  strokeOpacity: 0.5,
  strokeWidth: 0.741,
  d: "M32 .37c10.836 0 19.63 8.912 19.63 19.916 0 8.01-3.957 17.067-8.443 24.145-2.239 3.533-4.6 6.556-6.642 8.69-1.022 1.068-1.958 1.906-2.753 2.475a6.5 6.5 0 0 1-1.06.635c-.312.14-.555.199-.732.199s-.42-.058-.731-.2a6.5 6.5 0 0 1-1.061-.634c-.795-.569-1.731-1.407-2.753-2.475-2.042-2.135-4.403-5.157-6.642-8.69-4.486-7.078-8.443-16.134-8.443-24.145C12.37 9.282 21.164.37 32 .37Z"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 29.63,
  height: 29.125,
  x: 17.185,
  y: 5.098,
  fill: "#4951EF",
  rx: 14.563
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 30.37,
  height: 29.866,
  x: 16.815,
  y: 4.727,
  stroke: "url(#map-marker-small_svg__c)",
  strokeOpacity: 0.5,
  strokeWidth: 0.741,
  rx: 14.933
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "map-marker-small_svg__b",
  x1: 32,
  x2: 32,
  y1: 0,
  y2: 56.8,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.471,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A1A1A1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "map-marker-small_svg__c",
  x1: 32,
  x2: 32,
  y1: 5.098,
  y2: 34.223,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A1A1A1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.529,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("filter", {
  id: "map-marker-small_svg__a",
  width: 63.704,
  height: 36.297,
  x: 0.148,
  y: 32.355,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_41029_4735",
  stdDeviation: 5.926
})))));
export { SvgMapMarkerSmall as ReactComponent };